import React from 'react';
import './Loader.css';

let LOADER_BAR_DEFAULT_WIDTH = 100;
let LOADER_BAR_DEFAULT_HEIGHT = 20;
let BOTTOM_SPACER_DEFAULT_HEIGHT = 5;


const Loader = (props) => {

  let loaderBarWidth = props.sizes[0] || LOADER_BAR_DEFAULT_WIDTH;
  let loaderBarHeight = props.sizes[1] || LOADER_BAR_DEFAULT_HEIGHT;
  let bottomSpacerHeight = props.spacer || BOTTOM_SPACER_DEFAULT_HEIGHT;

  let loaderBarCtnStyle = {
    height: `${loaderBarHeight}px`
  }

  let loaderBarStyle = {
    width: `${loaderBarWidth}%`,
    height: `${loaderBarHeight}px`
  }

  let bottomSpacerStyle = {
    width: '100%',
    height: `${bottomSpacerHeight}px`
  }

  let leftCoverStyle = null;
  let rightCoverStyle = null;

  if (loaderBarWidth !== 100) {

    let sideCoverWidth = (100 - loaderBarWidth) / 2;

    leftCoverStyle = {
      height: `${loaderBarHeight}px`,
      width: `${sideCoverWidth}%`
    }

    rightCoverStyle = {
      height: `${loaderBarHeight}px`,
      width: `${sideCoverWidth}%`
    }

    if (props.align) {
      if (props.align === 'left') {
        loaderBarStyle.order = -1;
      }
      if (props.align === 'right') {
        rightCoverStyle.order = -1;
      }
    }
  }

  return (
    <React.Fragment>
      <div className="LoaderBarCtn" style={loaderBarCtnStyle}>

        {leftCoverStyle && <div className="LoaderCoverStyle" style={leftCoverStyle}></div>}
        <div style={loaderBarStyle}></div>
        {rightCoverStyle && <div className="LoaderCoverStyle" style={rightCoverStyle}></div>}
        
      </div>
      <div className="LoaderCoverStyle" style={bottomSpacerStyle}></div>
    </React.Fragment>
  );
}


const LoaderContainer = (props) => {

  let placeholderBlockHeight = 0;

  React.Children.map(props.children, (loaderBar, index) => {
    placeholderBlockHeight += loaderBar.props.sizes[1] ? loaderBar.props.sizes[1] : LOADER_BAR_DEFAULT_HEIGHT;
    placeholderBlockHeight += loaderBar.props.spacer ? loaderBar.props.spacer : BOTTOM_SPACER_DEFAULT_HEIGHT;
  });

  let placeholderBlockStyle = {
    height: `${placeholderBlockHeight}px`
  }

  return (
    <div className="PlaceholderBlock" style={placeholderBlockStyle}>
      <div className="AnimatedBackgroundCtn">
        {props.children}
      </div>
    </div>
  );
}


export { Loader, LoaderContainer };


// WEBPACK FOOTER //
// ./src/components/Loader/Loader.js